import React, { useEffect, useState } from 'react';
import '../styles/IndividualProduct.scss';
import View from '../components/View';
import ProductPageHeader from '../components/ProductPageHeader';
import ProductCard from '../components/ProductCard';
import { useQuery, getCategoryBannerImage } from '../helpers/functions';
import { useDispatch, useSelector } from 'react-redux';
import { getProduct, getProducts } from '../selectors/Product';
import ProductImage from '../components/ProductImage';
import orangeCheckmarkSvg from '../assets/svgs/orange-checkmark.svg';
import history from '../helpers/history';
import c from '../helpers/constants';
import { fetchProduct, fetchProducts, setProduct } from '../actions/Product';
import { fetchProductTypes } from '../actions/ProductType';
import { fetchPrice } from '../actions/Price';
import { getPrice } from '../selectors/Price';
import { fetchStock } from '../actions/Stock';
import { getStock } from '../selectors/Stock';
import { getProductTypes } from '../selectors/ProductType';
import ProductCardEx from '../components/ProductCardEx';
import ProductCardY from '../components/ProductCardY';


const IndividualProducts = () => {

  const query = useQuery();
  const dispatch = useDispatch();
  const [sku, setSku] = useState(query.get('sku'));
  const [fetchedOnce, setFetchedOnce] = useState(false);
  const current = useSelector(getProduct);
  const similar = useSelector(getProducts);
  const price = useSelector(getPrice);
  const stock = useSelector(getStock);
  const productTypes = useSelector(getProductTypes);
  const isPacksPallets = current && (current?.product_type_code === 'L' || current?.product_type_code === 'N');
  const isCarpets = current && (current?.WIDTH1 !== 0 || current?.WIDTH2 !== 0 || current?.WIDTH3 !== 0 || current?.WIDTH4 !== 0);
  const isOther = !isCarpets && !isPacksPallets;
  const category = productTypes.find(pt => pt.product_type_code === current?.product_type_code);

  useEffect(() => {
    if (sku) {
      dispatch(fetchProduct(sku));
      dispatch(fetchProductTypes());
    }
  }, [dispatch]);

  useEffect(() => {
    if (current && !fetchedOnce && current?.product_sku === sku) {
      dispatch(fetchProducts(current?.product_type_code, undefined, current?.quality_full_name));
      setFetchedOnce(true);
    }
    if (current) {
      dispatch(fetchPrice(current.product_sku));
      dispatch(fetchStock(current.product_sku));
    }
  }, [current, sku]);

  const changeProduct = (code: string) => {
    setSku(code);
    history.push({ pathname: `${c.APP_ROUTES.PRODUCT_CUT}`, search: `?sku=${code}` });
    const prod = similar?.find(s => s.product_sku === code);
    if (prod) {
      dispatch(setProduct(prod));
    }
  };

  const productType = productTypes.find(pt => pt.product_type_code === current?.product_type_code);

  return (
        <View>
            <ProductPageHeader
                topText={category?.product_type_desc || ''}
                bottomText={current?.quality_full_name || ''}
                imageUrl={getCategoryBannerImage(current?.product_type_code)}
            />
            <div className="container pb-5">
                <h3 className="product-title pb-3 font-bold">
                    {current?.quality_full_name} {current?.colour_full_name}
                </h3>
                <p className="pt-5 pb-4 font-bold">Select Colour</p>
                <div className="row g-5">
                    <div className="col-lg-6 col-md-12">
                        <div className="row gy-4">
                            {similar?.map(s => (
                                <div key={s.product_sku} onClick={() => changeProduct(s.product_sku)} className="col-lg-4 col-md-4 col-sm-4">
                                    <div className="center-align product">
                                        <div>
                                            {s.product_sku === current?.product_sku && <img src={orangeCheckmarkSvg} className="product__checkmark" />}
                                            <ProductImage className={`product__image ${s.product_sku === current?.product_sku ? 'product__image__active' : ''}`} imageCode={s.product_sku} imageAlt={s.colour_full_name} />
                                        </div>
                                        <p>{s.colour_full_name}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        {current && isCarpets && <ProductCard product={current} stock={stock} price={price} productType={productType}/>}
                        {current && isPacksPallets && <ProductCardEx product={current} stock={stock} price={price} productType={productType}/>}
                        {current && isOther && <ProductCardY product={current} stock={stock} price={price} productType={productType}/>}
                    </div>
                </div>
            </div>
        </View>
  );
};

export default IndividualProducts;
